var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:{ large: _vm.large }},[(_vm.image && _vm.imagePath)?_c('img',{staticClass:"mr-3",attrs:{"src":_vm.imagePath,"alt":"icon"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }